import { createReducer } from '@reduxjs/toolkit'

import {
  ChatterOverviewComparison,
  ChatterOverviewSales,
  ChatterOverviewStatistics,
  ChatterPerformance,
} from '@/model/analytics'

import {
  chatterReportsNamespace,
  readChatterOverviewComparison,
  readChatterOverviewSales,
  readChatterOverviewStatistics,
  readChatterPerformance,
} from './chatter-reports-actions'

const initialState: {
  chatterOverviewSales?: ChatterOverviewSales
  chatterOverviewStatistics?: ChatterOverviewStatistics
  chatterOverviewComparison?: ChatterOverviewComparison
  chatterPerformance?: ChatterPerformance
} = {}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(readChatterOverviewSales.fulfilled, (draft, { payload }) => {
    draft.chatterOverviewSales = payload
  })

  builder.addCase(readChatterOverviewComparison.fulfilled, (draft, { payload }) => {
    draft.chatterOverviewComparison = payload.data
  })

  builder.addCase(readChatterOverviewStatistics.fulfilled, (draft, { payload }) => {
    draft.chatterOverviewStatistics = payload.data
  })

  builder.addCase(readChatterPerformance.fulfilled, (draft, { payload }) => {
    draft.chatterPerformance = payload.data
  })
})

export default { [chatterReportsNamespace]: reducer }


